import { NavigationState, PartialState, Route } from '@react-navigation/native';

type NavState = NavigationState | PartialState<NavigationState>;

export const BACKGROUND_MODAL_ROUTES = new Set<string>([
	'Ranking',
	'VipTables',
	'JoinTournaments',
	'Login',
	'Settings',
	'Invites',
	'Messages',
	'Conversations',
	'BlockList',
	'PrivateChat',
	'Help',
	'Profile',
	'BuyPackages',
	'GameRules',
	'MyTables',
	'Search',
	'PersonalData',
]);

/**
 * Every route presented as a see-through overlay (`transparentModal` / the side-menu modal
 * options in `navigator.tsx`): the screen under it stays on screen around the panel.
 */
export const OVERLAY_ROUTES = new Set<string>([
	...BACKGROUND_MODAL_ROUTES,
	'Inventory',
	'Achievements',
]);

/**
 * Overlays whose phone artboard shows the live screen under the scrim rather than a repainted
 * backdrop - Figma "01 · Entry point" (4488:19598) puts Home, nav and all, behind Achievements.
 * The screen underneath has to keep its body while one of these is on top.
 */
export const PHONE_SEE_THROUGH_ROUTES = new Set<string>(['Achievements']);

export const getBackgroundBaseRoute = (state: NavState): string | undefined => {
	const activeIndex = typeof state.index === 'number' ? state.index : state.routes.length - 1;
	if (activeIndex < 0) return undefined;

	const currentRoute = state.routes[activeIndex]?.name;
	if (currentRoute == null) return undefined;

	if (!BACKGROUND_MODAL_ROUTES.has(currentRoute)) {
		return currentRoute;
	}

	for (let i = activeIndex - 1; i >= 0; i -= 1) {
		const route = state.routes[i] as Route<string> | undefined;
		const routeName = route?.name;
		if (routeName != null && !BACKGROUND_MODAL_ROUTES.has(routeName)) {
			return routeName;
		}
	}

	return currentRoute;
};
